import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import type { products } from "@/Models/MProduct/Products";
import { formatMX } from "@/Utils/Fomat.price";

const normalizeToArray = (data: products | products[]): products[] => {
  return Array.isArray(data) ? data : [data];
};

export const mappersPDP = (
  data: products | products[],
  category: string,
  subCategory: string,
  ipClient: string
) => {
  if (data && category != "" && subCategory != "" && ipClient != "") {
    const dataPDP = (x: products): ProductByIdPdp => {
      return {
        Id: x.Id,
        Name: x.Name,
        Brand: x.Brand,
        PricePerUnit: x.PricePerUnit,
        Price: x.Price,
        ImageGroups: x.ImageGroups,
        ImageZoomGroups: x.ImageZoomGroups,
        LongDescription: x.LongDescription,
        CCategory: x.CCategory, //cCategory,
        CTab2Content: x.CTab2Content,
        Caracteristicas: x.Caracteristicas,
        ListPriceBasket: x.ListPrice,
        SalesPriceBasket: x.SalesPrice,
        ListPrice: formatMX(x.ListPrice),
        SalesPrice: formatMX(x.SalesPrice),
        CBvAverageRating: x.CBvAverageRating,
        CratesAndReviews: x.CRatesAndReviews,
        CBvRatingRange: x.CBvRatingRange,
        CConversionFactor: x.CConversionFactor,
        Unit: x.Unit,
        CSalesUnit: x.CSalesUnit,
        ListPrice_v2: x.ListPrice,
        Ean: x.Ean,
        IsDigital: x.IsDigital,
        CSaleLimit: x.CSaleLimit,
        CBadges: x.CBadges,
        MinOrderQuantity: x.MinOrderQuantity,
        StepQuantity: x.StepQuantity,
        SellLimit: x.CSaleLimit,
        Category: x.PrimaryCategoryId,
        SubCategory: x.CCategory,
        Default: x.Default,
        IpClient: ipClient,
        XDefect: "Electrónica",
        Promotions: x.Promotions,
      };
    };

    const resultData = normalizeToArray(data).map(dataPDP);

    return resultData;
  }
  return [];
};
